import {
  SET_CUSTOMER_REPORTS_LOADING,
  GET_CUSTOMER_REPORTS_SUCCESS,
  GET_CUSTOMER_REPORTS_ERROR,
} from './types';
import store from '../../../../store';
import Axios from '../../../../common/util/Axios';

export const getCustomerReports = (params) => async (dispatch) => {
  try {
    dispatch({ type: SET_CUSTOMER_REPORTS_LOADING, payload: true });

    const companyId = store.getState().authState.companyId;
    const branchId = store.getState().authState.branchId;

    const queryParams = {
      companyId,
      branchId,
      ...params,
    };

    const res = await Axios.get(`/api/dashboard/customers/find-with-sales`, {
      params: queryParams,
    });

    dispatch({
      type: GET_CUSTOMER_REPORTS_SUCCESS,
      payload: {
        data: res.data.data,
        pagination: res.data.pagination,
      },
    });
  } catch (err) {
    dispatch({
      type: GET_CUSTOMER_REPORTS_ERROR,
      payload: err.message || 'Failed to fetch customer reports',
    });
  }
};

export const setCustomerReportsLoading = (loading) => ({
  type: SET_CUSTOMER_REPORTS_LOADING,
  payload: loading,
});

export const clearCustomerReportsError = () => ({
  type: GET_CUSTOMER_REPORTS_ERROR,
  payload: null,
});

export const exportCustomerReports = (params) => async (dispatch) => {
  try {
    const companyId = store.getState().authState.companyId;
    const branchId = store.getState().authState.branchId;

    // Generate timestamp for unique filename
    const getTimestampString = () => {
      const pad = (num) => String(num).padStart(2, '0');
      const d = new Date();
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(
        d.getDate()
      )}_${pad(d.getHours())}-${pad(d.getMinutes())}-${pad(d.getSeconds())}`;
    };

    const requestBody = {
      columns: [
        {
          key: 'id',
          header: 'Customer ID',
        },
        {
          key: 'name',
          header: 'Customer Name',
        },
        {
          key: 'phone',
          header: 'Phone Number',
        },
        {
          key: 'total_buys',
          header: 'Total Sales Amount',
        },
      ],
      filename: `customers_with_sales_export_${getTimestampString()}.xlsx`,
      sheetName: 'Customers with Sales',
      companyId,
      branchId,
      ...params,
    };

    const response = await Axios.post(
      '/api/dashboard/customers/export-customers-with-sales-excel',
      requestBody,
      {
        responseType: 'blob',
        headers: {
          Accept:
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        },
      }
    );

    const contentDisposition = response?.headers?.['content-disposition'];
    let downloadFileName =
      requestBody.filename || `customers_with_sales_export.xlsx`;
    if (contentDisposition && contentDisposition.includes('filename=')) {
      const match = contentDisposition.match(
        /filename\*=UTF-8''([^;]+)|filename="?([^";]+)"?/i
      );
      downloadFileName = decodeURIComponent(
        match?.[1] || match?.[2] || downloadFileName
      );
    }

    const blob = new Blob([response.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', downloadFileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Export failed', error);
  }
};
